// src/pages/About.jsx
const About = () => {
  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      minHeight: '100vh',
      background: 'linear-gradient(to bottom, #ffffff, #f8f8f8)'
    }}>
      <main style={{
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        padding: '40px'
      }}>
        <div style={{
          alignSelf: 'flex-start',
          width: '100%',
          maxWidth: '1200px',
          margin: '0 auto'
        }}>
          <h1 style={{ 
            color: '#ff54a9',
            fontSize: '4rem',
            fontWeight: 'bold',
            textShadow: '4px 4px 8px rgba(0, 0, 0, 0.2)',
            marginBottom: '30px'
          }}>
            About Us
          </h1>
          
          <div style={{
            fontSize: '1.2rem',
            lineHeight: '1.8',
            color: '#333',
            textAlign: 'left'
          }}>
            <p style={{ fontSize: '1.8rem', fontWeight: 'bold', marginBottom: '20px' }}>
              Welcome to Yogvital — Sowing Seeds of Wellness!
            </p>
            
            <p style={{ marginBottom: '20px' }}>
              Yogvital is a dynamic platform dedicated to promoting health and well-being by connecting passionate wellness educators with eager learners. Whether you're a yoga instructor, gym trainer, dietitian, astrologer, ayurvedacharya, or specialize in any other wellness-related field, our platform offers you a unique opportunity to reach a wider audience.
            </p>
            
            <p style={{ marginBottom: '20px' }}>
              As a user, you can enroll in various courses and services to enhance your health journey, while educators can join our network to share their expertise. Our business model operates on a commission basis: instructors earn income for each enrollment generated through Yogvital.
            </p>
            
            <h2 style={{ 
              fontSize: '1.5rem',
              fontWeight: 'bold',
              color: '#ff54a9',
              margin: '30px 0 15px 0'
            }}>
              What We Offer:
            </h2>
            
            <ul style={{ 
              marginBottom: '30px',
              paddingLeft: '20px'
            }}>
              <li style={{ marginBottom: '10px' }}>
                A seamless connection between wellness educators and students, expanding your reach and income.
              </li>
              <li style={{ marginBottom: '10px' }}>
                Multiple revenue streams from course enrollments, tutorials, and personalized services.
              </li>
              <li style={{ marginBottom: '10px' }}>
                Strong partnerships with qualified professionals committed to delivering quality wellness education.
              </li>
            </ul>
            
            <p style={{ fontWeight: 'bold' }}>
              Join Yogvital today to grow your wellness practice and help others thrive on their health journey!
            </p>
          </div>
        </div>
      </main>
    </div>
  );
}

export default About;